<template>
    <div class="modal fade" id="buscarDenuncia">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">Buscar Denúncia</h4>
					<button type="button" class="close" @click="close">&times;</button>
				</div>

				<div class="modal-body">
					<div class="d-flex flex-row bd-highlight mb-3">
						<div class="p-2">
							<div class="form-check">
								<label class="form-check-label">
									<input type="checkbox" class="form-check-input" v-model="show_analise">Adicionar análise
								</label>
							</div>
						</div>

						<div class="p-2">
							<div class="form-check">
								<label class="form-check-label">
									<input type="checkbox" class="form-check-input" v-model="show_transcricao">Adicionar transcrição
								</label>
							</div>
						</div>
					</div>

					<filtros :filter_data="filter_data" :hidden_search="true" :show_btn="true" @filtrar="filtrar" />

					<div class="row">
						<div class="col-md-12">
							<table class="table table-striped table-hover table-sm">
								<thead>
									<th>ID</th>
									<th>Protocolo</th>
									<th>Data</th>
									<th>Hora</th>
									<th>Origem</th>
								</thead>
								
								<transition mode="out-in" name="leftIn">
									<Loading v-if="loading" />

									<tbody v-else>
										<tr v-for="row in audios" :key="row.ID" data-f='date' @click="select(row)" class="pointer">
											<td> {{ row.id }}        </td>
											<td> {{ row.protocolo }} </td>
											<td> {{ row.created_at | moment("DD/MM/YYYY") }}  </td>
											<td> {{ convert_hor(row.created_at) | moment("HH:mm:ss") }} </td>
											<td> {{ Phone(row.origem) }}</td>
										</tr>
									</tbody>
								</transition>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api 	   from "@/mixins/api.js"
	import replace from "@/mixins/replace.js"
	import filtros from "@/components/Tools/filter.vue"

    export default {
    	name: "modal-audio",
    	mixins: [ api, replace ],
    	components: { filtros },

    	data: () => { return {
    		audios: null,
    		loading: false,
    		string_filter: "",
    		direction: { order: "desc", by: "id" },
    		show_analise: true,
			show_transcricao: true,

    		filter_data: [
				{ name: "protocolo",         label: "protocolo",      type: "text",   data_get: ""},
				{ name: "created_at", label: "data",    type: "date",   data_get: ""},
				{ name: "id", label: "id",    type: "text",   data_get: ""},
			]
    	}},

    	computed: {
    		ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},
    	},

    	methods: {
    		async get_data() {
    			this.loading = true
    			const response = await this.GET("Denuncia", `Paginate/100?${this.ordenation}${this.string_filter}`)
    			this.loading = false

    			if (response.status == 'success')
    				this.audios = response.result.data
    		},

    		select(payload) {
    			const data = {
    				gravacao: payload,
    				show_analise: this.show_analise,
    				show_transcricao: this.show_transcricao,
    			}

    			this.$emit('select', data)
    			this.close()
    		},

    		close() {
    			$("#buscarDenuncia").modal('hide')
    		},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			filtrar(payload) {
				this.string_filter = payload
				this.get_data()
			},
    	}
    }
</script>

<style scoped>
</style>
